import { create } from 'zustand';

export const useCorrelationViewSelected = create((set) => ({
  viewSelected: '',
  setViewSelected: (view: string) => set(() => ({ viewSelected: view }))
}));

export const useCorrelationSlide = create((set) => ({
  valueSlide: 45,
  setValueSlide: (number: number) => set(() => ({ valueSlide: number }))
}));

export const useCorrelationRowsGrid = create((set) => ({
  rowsAgGrid: [],
  setRowsAgGrid: (data: any) => set(() => ({ rowsAgGrid: data }))
}));

export const useCorrelationRowsGridFiltered = create((set) => ({
  rowsDataFiltered: [],
  setRowsDataFiltered: (data: any) => set(() => ({ rowsDataFiltered: data }))
}));

export const useSignalsDateFormatData = create((set) => ({
  dateSignalsData: undefined,
  setDateSignalsData: (data: any) => set(() => ({ dateSignalsData: data }))
}));

export const useCorrelationViewsData = create((set) => ({
  viewDataSelected: [],
  setViewDataSelected: (data: any[]) => set(() => ({ viewDataSelected: data }))
}));

export const useCorrelationCounter = create((set) => ({
  counter: 0,
  setCounter: (amount: number) => set(() => ({ counter: amount }))
}));

export const useAccordionUICorrelation = create((set) => ({
  accordionData: null,
  setAccordion: (data: any) => set(() => ({ accordionData: data }))
}));

export const useCorrelationDateFormatData = create((set) => ({
  dateCorrelationData: undefined,
  setDateCorrelationData: (data: any) => set(() => ({ dateCorrelationData: data }))
}));

export const useCorrelationButtonGoStatus = create((set) => ({
  isClicked: false,
  setIsClicked: (doClick: boolean) => set(() => ({ isClicked: doClick }))
}));

export const useCorrelationValuesUpdatedFromAI = create((set) => ({
  updated: false,
  setUpdated: (isUpdated: boolean) => set(() => ({ updated: isUpdated }))
}));

export const useShowUpDataAI = create((set) => ({
  isClicked: false,
  setIsClicked: (doClick: boolean) => set(() => ({ isClicked: doClick }))
}));

export const usePayloadAIExplainerCorrelation = create((set) => ({
  data: null,
  setData: (data: any) => set(() => ({ data: data }))
}));

export const useShowAIExplainerCorrelation = create((set) => ({
  showExplainer: false,
  setShowExplainer: (showExplainer: boolean) => set(() => ({ showExplainer: showExplainer }))
}));

export const useAIExplainerCorrelation = create((set) => ({
  explainer: '',
  setExplainer: (explainer: string) => set(() => ({ explainer: explainer }))
}));

export const useAIExplainerCorrelationsArray = create((set) => ({
  explainer: [],
  setExplainer: (explainer: any) => set(() => ({ explainer: explainer }))
}));

interface CorrelationsState {
  filters: any[];
}
interface CorrelationsStore {
  correlations: CorrelationsState | null;
  setCorrelations: (filters: any[]) => void;
  clearCorrelations: () => void;
}
export const useCorrelationStore = create<CorrelationsStore>((set) => ({
  correlations: null,
  setCorrelations: (filters) =>
    set({
      correlations: {
        filters: filters
      }
    }),
  clearCorrelations: () => set({ correlations: null })
}));

export const useShowLoader = create((set) => ({
  showLoader: false,
  setShowLoader: (showLoader: boolean) => set(() => ({ showLoader: showLoader }))
}));
